<wiz-group width="100%" height="100%" gap="2" class="section-container" style="padding: 0 !important;">
 
 <wiz-hgroup width="100%" height="100%">
    <pinch-zoom width="100%" height="100%" backgroundColor="rgba(255,255,255,1)" [limit-zoom]="20" [minScale]="2" >
      <!-- <div style="display: inline-block;position: relative; max-width:100%; max-height: 100%;"> -->
          <wiz-image
            #img
            tabindex="0"
            height="100%"
            width="100%"
            class="img-freestyle"
            [sourceObservable]="imgSrcObs"
            style="pointer-events: none; object-fit:contain"
            >
          ></wiz-image>
        
        <!-- <img [src]="imgSource" style="display: block;pointer-events: none; width: 100%; height: 100%; object-fit:contain"/> -->
        <!-- <div #over style='top: 0; left: 0; z-index: 100; width:100%; height:100%; position: absolute; outline: none; box-shadow: none;'></div>
      </div> -->
      
    </pinch-zoom>
  </wiz-hgroup>

 <wiz-hgroup width="100%" style="padding:5px" horizontalAlign="end">
    

    <wiz-spacer width="100%"></wiz-spacer>
    <wiz-icon  
        class="image-back-white t30" [visible]="showNavigation"
        (click)="go(-1)" [wizTooltip]="'$.common.export.$'"><mat-icon style="font-size: 30px;">arrow_back</mat-icon></wiz-icon>
    
        <wiz-icon [visible]="showNavigation"
        class="image-back-white t30"
        (click)="go(1)" [wizTooltip]="'$.common.export.$'"><mat-icon style="font-size: 30px;">arrow_forward</mat-icon></wiz-icon>

    <wiz-spacer width="20px"></wiz-spacer>   
    <wiz-icon #icoOcr [visible]="showOCR"
            class="image-back-white t30"
            (click)="recognizeOCR(imgSrcObs)"
            [wizTooltip]="'$.image.mode.ocr.$'">
            <mat-icon>qr_code_scanner</mat-icon></wiz-icon>

    <wiz-spacer width="20px"></wiz-spacer>

    <wiz-icon class="image-back-white t30" 
         (click)="doCancel()"><mat-icon>close</mat-icon></wiz-icon>

  </wiz-hgroup>

</wiz-group>
